export default __webpack_public_path__ + "static/media/icon4_blue.556f9259.svg";